
const whiteList = [
  'login',
  'login-mobile',
  'anonymity-query',
  'anonymity-query-mobile',
  'a',
  'look-openid',
  'wxAuth',
  'scanCode',
  'result-checking',
];

export default whiteList